export default "__VITE_ASSET__CXl5qH0b__"